import React, {useState, useEffect} from "react";
import {TextField, DialogContent, DialogActions} from "@material-ui/core";
import {Button, Grid} from "@material-ui/core";
import {Autocomplete} from "@material-ui/lab";
import axios from "axios";
import {Close, Save} from "@material-ui/icons";
import {getCookie} from "../../../components/auth/Helpers";

import "react-dropzone-uploader/dist/styles.css";

const FilterComponent = (props) => {
  const token = getCookie("token");
  const [clientsList, setClientsList] = useState([]);
  const [fridgesTypesList, setFridgesTypesList] = useState([]);
  const [statusList, setStatusList] = useState([
    "Operational",
    "Quarantine",
    "Major Maintenance",
    "Damaged",
    "Discontinued",
  ]);
  const [prevStatusList, setPrevStatusList] = useState(["Due", "Recomended"]);
  const [storesList, setStoresList] = useState([]);
  const [warehousesList, setWarehousesList] = useState([]);
  const [formValues, setFormValues] = useState({
    client: "",
    fridgesType: "",
    status: "",
    prevStatus: "",
    fromDate: "",
    toDate: "",

    location: "",
    store: "",
    warehouse: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      await axios
        .all([
          axios.get(`${process.env.REACT_APP_BASE_URL}/clients`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/fridgesTypes`, {
            headers: {Authorization: `Bearer ${token}`},
          }),

          axios.get(`${process.env.REACT_APP_BASE_URL}/stores`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/warehouses`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
        ])
        .then((response) => {
          setClientsList(response[0].data);
          setFridgesTypesList(response[1].data);

          setStoresList(response[2].data);
          setWarehousesList(response[3].data);
        });
    };
    fetchData();
  }, []);

  const handleChangeAutoComplete = (e, newValue, name) => {
    if (newValue) setFormValues({...formValues, [name]: newValue});
  };

  const handleSearchDate = (e) => {
    const {name, value} = e.target;
    if (value) setFormValues({...formValues, [name]: value});
  };

  const handleOnSubmit = async () => {
    let filterArray = [];

    if (props.formValues.operationType) filterArray.push(`operationType=${props.formValues.operationType}`);
    if (props.formValues.from_warehouse)
      filterArray.push(`from_warehouse=${props.formValues.from_warehouse}`);

    if (props.formValues.warehouse) filterArray.push(`warehouse=${props.formValues.warehouse}`);

    if (props.formValues.condition) filterArray.push(`condition=${props.formValues.condition}`);

    if (formValues.location) filterArray.push(`location=${formValues.location.id}`);
    if (formValues.store) filterArray.push(`location_id=${formValues.store._id}`);
    if (formValues.warehouse) filterArray.push(`location_id=${formValues.warehouse._id}`);

    if (formValues.client._id) filterArray.push(`clientId=${formValues.client._id}`);
    if (formValues.fridgesType._id) filterArray.push(`fridgeTypeId=${formValues.fridgesType._id}`);
    if (formValues.prevStatus) filterArray.push(`prevStatus=${formValues.prevStatus}`);
    if (formValues.status) filterArray.push(`status=${formValues.status}`);
    if (formValues.fromDate) filterArray.push(`fromDate=${formValues.fromDate}`);
    if (formValues.toDate) filterArray.push(`toDate=${formValues.toDate}`);
    await axios(`${process.env.REACT_APP_BASE_URL}/cabinets?${filterArray.join("&")}`, {
      responseType: "json",
      headers: {Authorization: `Bearer ${token}`},
    })
      .then(function (response) {
        // props.setItems(response.data.data);
        const prev = response.data.data;

        props.setItems(
          !Array.isArray(prev)
            ? []
            : prev.filter((e) => {
                if (e.booked) return false;
                return !props.snFilled.includes(e.sn);
              })
        );

        props.setPagingInfo({...props.pagingInfo, count: response.data.count});

        props.setOpenDialog(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <DialogContent dividers>
        <h3>Cabinets Report Filter</h3>
      </DialogContent>
      <DialogContent dividers>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="ClientInput"
              options={clientsList || {}}
              value={formValues.client || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "client")}
              renderInput={(params) => <TextField {...params} label="Client" name="client" />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="fridgesTypeInput"
              options={fridgesTypesList || {}}
              value={formValues.fridgesType || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "fridgesType")}
              renderInput={(params) => <TextField {...params} label="Fridges Type" />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="statusInput"
              options={statusList}
              value={formValues.status || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "status")}
              renderInput={(params) => <TextField {...params} label="Status" />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="prevStatusInput"
              options={prevStatusList}
              value={formValues.prevStatus || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "prevStatus")}
              renderInput={(params) => <TextField {...params} label="Preventive Status" />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              id="fromDate"
              name="fromDate"
              label="From Date"
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleSearchDate}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              id="toDate"
              name="toDate"
              label="To Date"
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleSearchDate}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="location"
              options={[
                {id: "store", name: "Store"},

                {id: "warehouse", name: "Warehouse"},
              ]}
              value={formValues.location || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "location")}
              renderInput={(params) => <TextField {...params} label="Location" name="location" />}
            />
          </Grid>

          {formValues.location && formValues.location.id == "store" && (
            <Grid item xs={12} sm={4}>
              <Autocomplete
                id="store"
                options={storesList}
                value={formValues.store || {}}
                getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
                fullWidth
                onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "store")}
                renderInput={(params) => <TextField {...params} label="Store" name="store" />}
              />
            </Grid>
          )}

          {formValues.location && formValues.location.id == "warehouse" && (
            <Grid item xs={12} sm={4}>
              <Autocomplete
                id="warehouse"
                options={warehousesList}
                value={formValues.warehouse || {}}
                getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
                fullWidth
                onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "warehouse")}
                renderInput={(params) => <TextField {...params} label="Site" name="warehouse" />}
              />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          className="btn btn--save"
          onClick={() => props.setOpenDialog(false)}
          startIcon={<Close />}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="large"
          className="btn btn--save"
          onClick={handleOnSubmit}
          startIcon={<Save />}
        >
          Save
        </Button>
      </DialogActions>
    </>
  );
};

export default FilterComponent;
